module.exports = __webpack_public_path__ + "static/media/Gold_banner1.49db02da.jpg";